<template>
  <Dialog
    v-model:visible="showConfirm"
    :modal="true"
    :closable="false"
    :draggable="false"
    class="custom-dialog fixNotchPaddingTop"
    :style="{ width: '500px', zIndex: 1100 }"
    :header="title"
  >
    <div class="flex flex-column align-items-center gap-3 p-4">
      <i
        class="pi pi-exclamation-circle text-7xl"
        style="color: var(--primary-color)"
      ></i>
      <p class="text-lg" style="color: var(--grey-text)">{{ message }}</p>
    </div>

    <template #footer>
      <Button
        :label="titleOk"
        class="footer-primary-button"
        variant="text"
        @click="doConfirm"
      />
      <Button
        v-if="!!titleCancel"
        :label="titleCancel"
        class="footer-button-cancel"
        variant="text"
        @click="doCancel"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Props
interface Props {
  message: string;
  titleOk: string;
  titleCancel?: string;
  title: string;
}

defineProps<Props>();

// Emits
const emit = defineEmits<{
  confirmed: [payload: any];
  canceled: [payload: any];
}>();

// State
const showConfirm = ref(false);
const payload = ref<any>(null);

// Methods (expuestos para llamadas externas)
function confirm(newPayload?: any) {
  payload.value = newPayload;
  showConfirm.value = true;
}

function doConfirm() {
  showConfirm.value = false;
  emit("confirmed", payload.value);
}

function doCancel() {
  showConfirm.value = false;
  emit("canceled", payload.value);
}

// Exponer métodos para que puedan ser llamados externamente (ref)
defineExpose({
  confirm,
});
</script>
<style scoped></style>
